import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M10.448 7.993c0 3-1.29 5.25-3 5.25a.75.75 0 0 1 0-1.5c.62 0 1.5-1.46 1.5-3.75s-.88-3.74-1.5-3.74a.75.75 0 0 1 0-1.5c1.71 0 3 2.247 3 5.24Zm-7.24-6.74a.75.75 0 0 0 0 1.5c1.06 0 2.25 2.24 2.25 5.24s-1.19 5.25-2.25 5.25a.75.75 0 0 0 0 1.5c2.13 0 3.75-2.9 3.75-6.75s-1.62-6.74-3.75-6.74Zm8.34 3.5a.756.756 0 0 0-.76.74.732.732 0 0 0 .73.75 2.317 2.317 0 0 1 .53 1.75 2.465 2.465 0 0 1-.5 1.75.75.75 0 0 0 0 1.5c1.16 0 2-1.36 2-3.25s-.84-3.24-2-3.24Z';
const draw24px =
  'M3.7,22.75a.75.75,0,1,1,0-1.5C5.75,21.25,8,17.53,8,12S5.75,2.75,3.7,2.75a.75.75,0,0,1,0-1.5C6.92,1.25,9.45,6,9.45,12S6.92,22.75,3.7,22.75ZM15.28,12c0-4.63-2-8.25-4.5-8.25a.75.75,0,0,0,0,1.5c1.42,0,3,2.77,3,6.75s-1.58,6.75-3,6.75a.75.75,0,0,0,0,1.5C13.3,20.25,15.28,16.63,15.28,12Zm5.17,0c0-2.8-1.22-4.92-2.84-4.92a.75.75,0,0,0,0,1.5C18.14,8.58,19,10,19,12s-.81,3.42-1.34,3.42a.75.75,0,0,0,0,1.5C19.23,16.92,20.45,14.8,20.45,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PhotosynthIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'photosynth'),
) as IconWithRender;

PhotosynthIcon.displayName = 'PhotosynthIcon';
PhotosynthIcon.propTypes = Icon.propTypes;
PhotosynthIcon.renderIcon = (props) => <PhotosynthIcon {...props} />;
export default PhotosynthIcon;
